import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getQuoteList = createAsyncThunk('/thunk/get-quote-by-master', async (ROWID) => {
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/crm/app/v1/get-quote-by-master/${ROWID}`,{page:1})
        // console.log("qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq",response)
        return response
        
    } catch (error) {
        throw error
    }
});    